'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

var _connectUpgradeData = require('ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData');

var _connectUpgradeData2 = _interopRequireDefault(_connectUpgradeData);

var _CheckoutButton = require('ui-addon-upgrades/_core/checkout/CheckoutButton');

var _CheckoutButton2 = _interopRequireDefault(_CheckoutButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHECKOUT = _sources.sourceKeys.CHECKOUT;
exports.default = (0, _connectUpgradeData2.default)(_CheckoutButton2.default, CHECKOUT);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/button/UICheckoutButton.js
// module id = 309
// module chunks = 3 4 5